var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-view"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings.settings')))]),_c('ProfileDataForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }